module.exports = __webpack_public_path__ + "static/img/logo.8e2637c4.png";